import { Component } from '@angular/core';

/**
 * Rendered via `MatDialog` (not a plain `position: fixed` div) so it is guaranteed to stack
 * above ANY currently-open `MatDialog` — e.g. the "create bill" dialog. A plain fixed-position
 * overlay competes with `.cdk-overlay-container` (z-index 1000) for stacking order and, in
 * practice, kept rendering behind open dialogs; MatDialog-over-MatDialog stacking is a
 * first-class supported Angular Material behavior, so this is immune to that issue.
 * See `AppComponent` (`SpinnerService.visibility` subscription) for how this is opened/closed.
 */
@Component({
    selector: 'app-global-spinner',
    templateUrl: './global-spinner.component.html',
    styleUrls: ['./global-spinner.component.scss'],
    standalone: false
})
export class GlobalSpinnerComponent {}
